import type { AudienceSegmentCombinedResult, AudienceSegmentSet } from '@openx/types/gqlTypes';

type AudienceSegmentSetWithNullableFields = Omit<AudienceSegmentSet, 'segmentIds'> & {
  segmentIds?: AudienceSegmentSet['segmentIds'] | null;
};

type AudienceSegmentCombinedResultWithNullableFields = Omit<AudienceSegmentCombinedResult, 'segmentsSets'> & {
  segmentsSets: AudienceSegmentSetWithNullableFields[];
};

export const normalizeAudienceSegmentSet = (segmentSet: AudienceSegmentSetWithNullableFields): AudienceSegmentSet => ({
  ...segmentSet,
  segmentIds: segmentSet.segmentIds ?? [],
});

export const normalizeAudienceSegmentSets = (
  segmentSets: AudienceSegmentSetWithNullableFields[]
): AudienceSegmentSet[] => segmentSets.map(normalizeAudienceSegmentSet);

export const normalizeAudienceSegmentCombinedResult = (
  combinedResult: AudienceSegmentCombinedResultWithNullableFields
): AudienceSegmentCombinedResult => ({
  ...combinedResult,
  segmentsSets: normalizeAudienceSegmentSets(combinedResult.segmentsSets),
});
